var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4091 7.64478C15.4091 9.74183 14.3248 12.6914 12 12.6914C9.67517 12.6914 8.59091 9.8544 8.59091 7.64478C8.59091 5.43515 10.1172 4 12 4C13.8828 4 15.4091 5.54773 15.4091 7.64478ZM4.9 20C4.67909 20 4.5 19.8575 4.5 19.6366V17.8768C4.5 15.3933 7.85786 14.0285 12 14.0285C16.1421 14.0285 19.5 15.3643 19.5 17.8768V19.6005C19.5 19.8214 19.3209 20 19.1 20H4.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ea77d46bd28bd7951dc2468d628afd69.svg";
export { ForwardRef as ReactComponent };